var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDCoolingDynamicRoomlevel = function SvgDCoolingDynamicRoomlevel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 204.99,
    y: 249,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.99,
    y: 262,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "209.98 264.01 217.13 276.5 202.85 276.5 209.98 264.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.98,265.02l6.29,10.98h-12.55s6.26-10.98,6.26-10.98M209.98,263l-7.98,14h16s-8.01-14-8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "202.85 249.51 217.13 249.5 209.98 261.99 202.85 249.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.26,250l-6.29,10.98-6.26-10.98h12.55M217.99,249h-16s7.98,14,7.98,14l8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 189,
    cy: 263,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,253c5.51,0,10,4.49,10,10s-4.48,10-10,10-10-4.49-10-10,4.48-10,10-10M189,252c-6.07,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.41,260.15v5.69h-.98v-1.87s.1-2.5.1-2.5l-1.68,4.38h-.71s-1.68-4.38-1.68-4.38l.1,2.51v1.87h-.98v-5.69h1.28s1.64,4.36,1.64,4.36l1.64-4.36h1.28Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 204.99,
    y: 281,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "209.98 296.01 217.13 308.49 202.85 308.5 209.98 296.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.98,297.02l6.29,10.97h-12.55s6.26-10.97,6.26-10.97M209.98,295l-7.98,14h16s-8.01-14-8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "202.85 281.51 217.13 281.5 209.98 293.99 202.85 281.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.26,282l-6.29,10.98-6.26-10.98h12.55M217.99,281h-16s7.98,14,7.98,14l8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 289,
    width: 5,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,290v10h-3v-10h3M227,289h-5v12h5v-12h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: 289,
    width: 5,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,290v10h-3v-10h3M232,289h-5v12h5v-12h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "225 289 224 289 224 279.5 210 279.5 210 278.5 225 278.5 225 289"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230 289 229 289 229 247.5 209.97 247.5 209.97 246.5 230 246.5 230 289"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 294,
    width: 12,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 246.5,
    width: 2,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 277,
    width: 2,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 398.99,
    y: 249,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.99,
    y: 262,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "403.98 264.01 411.13 276.5 396.85 276.5 403.98 264.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.98,265.02l6.29,10.98h-12.55s6.26-10.98,6.26-10.98M403.98,263l-7.98,14h16s-8.01-14-8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "396.85 249.51 411.13 249.5 403.98 261.99 396.85 249.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.26,250l-6.29,10.98-6.26-10.98h12.55M411.99,249h-16s7.98,14,7.98,14l8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 383,
    cy: 263,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,253c5.51,0,10,4.49,10,10s-4.48,10-10,10-10-4.49-10-10,4.48-10,10-10M383,252c-6.07,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.41,260.15v5.69h-.98v-1.87s.1-2.5.1-2.5l-1.68,4.38h-.71s-1.68-4.38-1.68-4.38l.1,2.51v1.87h-.98v-5.69h1.28s1.64,4.36,1.64,4.36l1.64-4.36h1.28Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 398.99,
    y: 281,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "403.98 296.01 411.13 308.49 396.85 308.5 403.98 296.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.98,297.02l6.29,10.97h-12.55s6.26-10.97,6.26-10.97M403.98,295l-7.98,14h16s-8.01-14-8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "396.85 281.51 411.13 281.5 403.98 293.99 396.85 281.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.26,282l-6.29,10.98-6.26-10.98h12.55M411.99,281h-16s7.98,14,7.98,14l8.01-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 289,
    width: 5,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,290v10h-3v-10h3M421,289h-5v12h5v-12h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 421,
    y: 289,
    width: 5,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,290v10h-3v-10h3M426,289h-5v12h5v-12h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "419 289 418 289 418 279.5 404 279.5 404 278.5 419 278.5 419 289"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424 289 423 289 423 247.5 403.97 247.5 403.97 246.5 424 246.5 424 289"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404,
    y: 294,
    width: 12,
    height: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 246.5,
    width: 2,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 277,
    width: 2,
    height: 4
  })))));
};
export default SvgDCoolingDynamicRoomlevel;